<template>
  <v-container grid-list-md fluid ma-3 text-xs-center>
    <v-layout justify-center wrap row v-if="invitation">
      <v-flex xs10 display-1 ma-3>
        Join <span style="font-weight:bold">{{invitation.School.name}}</span>
      </v-flex>
      <v-flex xs8 elevation-2 white pa-3 style="max-width:550px">
        <v-container fluid pa-3>
          <v-layout justify-center wrap>
            <form v-on:keyup.enter="register">
                <v-layout justify-center align-start>
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12 mb-4>
                        <v-alert
                          :value="error"
                          type="error"
                          outline
                        >
                          {{ error }}
                        </v-alert>
                      </v-flex>
                      <v-flex xs12 my-1>
                        <v-text-field
                          outline
                          color="secondary"
                          label="First Name"
                          v-model="firstname"
                          :rules="[rules.required]"
                          autofocus
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 my-1>
                        <v-text-field
                          outline
                          color="secondary"
                          label="Last Name"
                          v-model="lastname"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 my-1>
                        <v-text-field
                          outline
                          color="secondary"
                          label="Password"
                          type="password"
                          v-model="password"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 my-1>
                        <v-text-field
                          outline
                          color="secondary"
                          label="Confirm Password"
                          type="password"
                          v-model="passwordConfirmation"
                          :rules="[rules.required, rules.confirm]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 text-xs-center>
                        <v-btn class="secondary ma-2"
                          color="#fff"
                          dark
                          @click="register">Join School</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </form>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data: function () {
    return {
      invitation: null,
      error: null,
      password: '',
      passwordConfirmation: '',
      firstname: '',
      lastname: '',
      rules: {
          required: value => !!value || 'Required.',
          confirm: value => this.password === value || 'Passwords must match'
      }
    }
  },
  components: {
  },
  mounted: async function () {
    const inviteCode = this.$route.params.code;

    try {
      const result = await AuthenticationService.getInvitationWithCode(inviteCode);

      this.invitation = result.data;
    } catch (err) {
      this.invitation = null;
    }
  },
  methods: {
    async register () {
      if (this.password !== this.passwordConfirmation) {
        return;
      }


      const payload = {
        username: this.invitation.username,
        password: this.password,
        firstname: this.firstname,
        lastname: this.lastname,
        school: this.invitation.School.name,
        invitation: this.invitation.uuid
      }

      try {
        const response = await AuthenticationService.registerWithInvitation(payload);
        
        this.$store.dispatch('setToken', response.data.token);
        this.$store.dispatch('setUser', response.data.user);

        this.$router.push({
          path: '/'
        })
      } catch(err) {
        this.error = err.response.data.error;
      }
      
    }
  }
}
</script>

<style scoped>

</style>
